import React from 'react';
import SignatureDishes from '../common/SignatureDishes';

const MenuSection: React.FC = () => (
  <div className="mt-12 text-center">
    <h2 className="font-charles text-maroon text-5xl sm:text-6xl md:text-7xl">
      Menu
    </h2>
    <p className="font-prosto text-maroon text-balance text-lg sm:text-xl md:text-2xl mt-4">
      Savor our signature dishes crafted with fresh,
      <br />
      local ingredients and a touch of Baja flair.
    </p>
    <SignatureDishes />
  </div>
);

export default MenuSection;
